import init from '../../helpers/init';

const {$, _} = init;
const BX = (<any>window).BX;

$(() => {
  $(document).on('click', '.js-faq-section-select', (e: JQuery.ClickEvent) => {
    e.preventDefault();
    let sectionId = jQuery(e.currentTarget).data('id');
    if(sectionId
      && sectionId !== ''
      && sectionId !== 'all'
      && parseInt(sectionId)) {
      jQuery('.js-faq-question').hide();
      jQuery('.js-faq-question[data-section=' + sectionId + ']').show();
    } else {
      jQuery('.js-faq-question').show();
    }
  });
});
